function cov_24o2ab110r() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/heights.ts";
  var hash = "c4c0aa433951d520b358fc2c9caed0af5fbddf94";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/heights.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 23
        },
        end: {
          line: 5,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 62
        },
        end: {
          line: 9,
          column: 90
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c4c0aa433951d520b358fc2c9caed0af5fbddf94"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24o2ab110r = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_24o2ab110r();
import { numbersObjWithUnits } from '../../helpers';
export var heights = (cov_24o2ab110r().s[0]++, {
  header: 60 // Copied over from node_modules/@opendoor/primer/stylesheets/market/variables.less

});
export var heightsWithUnits = (cov_24o2ab110r().s[1]++, numbersObjWithUnits(heights));